import { useHotkeys } from "react-hotkeys-hook";

// Record navigation shared by edit scenes: ↑/K previous, ↓/J next (gated by list bounds),
// Escape to go back. Not enabled in inputs — you're typing in the form there.
const useRecordNavShortcuts = ({ onPrev, onNext, onBack, canPrev = true, canNext = true, backEnabled = true }, deps) => {
  useHotkeys("up", onPrev, { enabled: canPrev, preventDefault: true }, deps);
  useHotkeys("k", onPrev, { enabled: canPrev, preventDefault: true }, deps);
  useHotkeys("down", onNext, { enabled: canNext, preventDefault: true }, deps);
  useHotkeys("j", onNext, { enabled: canNext, preventDefault: true }, deps);
  useHotkeys("escape", onBack, { enabled: backEnabled, preventDefault: true }, deps);
};

export default useRecordNavShortcuts;
